import { createSlice } from "@reduxjs/toolkit";

interface InitialState {
  reset: {
    username: string;
    cardNumber: string;
    accountNumber: string;
  };
  resetActiveStep: number;
  verificationId: string;
  challenge?: string;
  isAuth: boolean;
  verificationPhone: string;
  resetActiveTab: string;
}

const initialState: InitialState = {
  reset: {
    username: "",
    cardNumber: "",
    accountNumber: "",
  },
  verificationId: "",
  resetActiveStep: 1,
  challenge: "",
  isAuth: false,
  verificationPhone: "",
  resetActiveTab: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setResetFields: (state, { payload }) => {
      state.reset = { ...state.reset, ...payload };
    },
    resetResetFields: (state) => {
      state.reset = { ...initialState.reset };
    },
    setVerificationId: (state, { payload }) => {
      state.verificationId = payload;
    },
    setChallenge: (state, { payload }) => {
      state.challenge = payload;
    },
    setIsAuth: (state, { payload }) => {
      state.isAuth = payload;
    },
    setResetActiveTab: (state, { payload }) => {
      state.resetActiveTab = payload;
    }
  },
});

export const {
  setResetFields,
  setVerificationId,
  resetResetFields,
  setChallenge,
  setIsAuth,
  setResetActiveTab,
} = authSlice.actions;
export default authSlice.reducer;
